








import Vue from 'vue';

export default Vue.extend({
  name: 'title-component',
  props: {
    variant: {
      type: String,
      default: 'contained'
    },
    color: {
      type: String,
      default: 'primary'
    },
    submitted : {
      type: Boolean,
      default: false
    }
  },
  computed: {
    buttonClass: function() {
      let output = `button-component--color-${this.color}`;

      output += ` button-component--${this.variant}`;

      output += this.submitted ? ' loading' : '';

      return output;
    },
    isDisabled: function () {
      return this.submitted;
    }
  }
});
